var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlaneHorizontalWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "plane-line"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1205_41092)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M15.5491 14.9006L10.4961 22.8995L8.49609 22.8995L11.0221 14.9006L5.66209 14.9006L3.99609 17.9002L2.49609 17.9002L3.49609 13.4008L2.49609 8.90141L3.99609 8.90141L5.66309 11.901L11.0231 11.901L8.49609 3.9021L10.4961 3.9021L15.5491 11.901L20.9961 11.901C21.3939 11.901 21.7754 12.059 22.0568 12.3403C22.3381 12.6215 22.4961 13.003 22.4961 13.4008C22.4961 13.7986 22.3381 14.18 22.0568 14.4613C21.7754 14.7426 21.3939 14.9006 20.9961 14.9006L15.5491 14.9006Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1205_41092"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 24.4961,
    y: 0.902588,
    width: 23.9967,
    height: 24,
    rx: 5,
    transform: "rotate(90 24.4961 0.902588)",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaneHorizontalWhite);
export default __webpack_public_path__ + "static/media/plane-horizontal-white.07d635765077d3d2a37a246066fa3441.svg";
export { ForwardRef as ReactComponent };